import React from 'react';

import styles from './heroError.module.css';

/**
 * 
 * @param {Object} props 
 * @param {JSX.Element} props.hero Svg Hero Icon 
 * @param {string} props.heading Heading 
 * @param {string} props.subtitle Subtitle 
 * @returns 
 */
export const HeroError = ({hero, heading, subtitle}) => {
    return <div className={styles.HeroError}>
        <div>
            {hero}
            <h1>{heading}</h1>
            <h2>{subtitle}</h2>
        </div>
    </div>
}